<template>
  <b-list-group flush class="mx-2 mt-2">
    <div v-for="attrib in attribs" v-bind:key="attrib.id">
      <div v-if="attrib.title">
        <h5 class="my-3">{{ attrib.title }}</h5>
      </div>
      <div v-else-if="attrib.bool">
        <b-list-group-item
          class="d-flex justify-content-between align-items-center border-right border-left border-0 p-0 m-0 mb-3 bg-light rounded"
          :class="attrib.value ? 'bool-success' : 'bool-danger'"
        >
          <b-avatar
            variant="dark"
            class="p-0 m-0 bv-avatar align-self-start"
            square
            style="min-width: 25px;"
          >
            <slot>
              <div v-if="attrib.img">
                <b-img :src="imgPath + attrib.img" fluid />
              </div>
              <div v-else>
                <font-awesome-icon
                  :icon="attrib.icon ? attrib.icon : 'question'"
                />
              </div>
            </slot>
          </b-avatar>
          <span class="flex-grow-1 text-responsive text-left mx-2 bool-text">
            {{ attrib.label }}
          </span>
          <span class="bool-icon mr-2 text-responsive">
            <font-awesome-icon
              :icon="attrib.value ? 'check-circle' : 'times-circle'"
              :class="attrib.value ? 'text-success' : 'text-danger'"
            />
          </span>
        </b-list-group-item>
      </div>
      <div v-else-if="attrib.justImg">
        <div v-if="attrib.label">
          <span class="label-text text-responsive">{{ attrib.label }}</span>
        </div>
        <b-img :src="imgPath + attrib.img" fluid />
      </div>
      <div v-else>
        <b-list-group-item
          class="d-flex justify-content-between align-items-center border-left border-right border-0 p-0 m-0 mb-3 py-2 bg-light rounded text-center"
          :class="
            'bool-' +
              progressVariant(attrib.value, attrib.maxValue, attrib.lessIsMore)
          "
        >
          <b-avatar
            variant="dark"
            class="p-0 m-0 bv-avatar align-self-start"
            square
            style="min-width: 25px;"
          >
            <slot>
              <div v-if="attrib.img">
                <b-img :src="imgPath + attrib.img" fluid />
              </div>
              <div v-else>
                <font-awesome-icon
                  :icon="attrib.icon ? attrib.icon : 'question'"
                />
              </div>
            </slot>
          </b-avatar>
          <div class="flex-grow-1 text-left ml-2">
            <span class="label-text text-responsive">{{ attrib.label }}</span>
            <span class="d-block d-xs-none d-sm-none text-responsive">{{
              attrib.valueLabel
            }}</span>
            <div class="d-flex justify-content-between align-items-center m-2">
              <font-awesome-icon
                :icon="attrib.lessIsMore ? 'smile' : 'frown'"
                :class="
                  'text-' +
                    frontIcon(attrib.value, attrib.maxValue, attrib.lessIsMore)
                "
              />
              <b-progress
                class="mx-1 rounded flex-grow-1"
                :max="1"
                show-value
                height="1.5rem"
              >
                <b-progress-bar
                  :value="attrib.value / attrib.maxValue"
                  :variant="
                    progressVariant(
                      attrib.value,
                      attrib.maxValue,
                      attrib.lessIsMore
                    )
                  "
                >
                  <slot
                    ><span class="d-none d-lg-block">{{
                      attrib.valueLabel
                    }}</span></slot
                  >
                </b-progress-bar>
              </b-progress>
              <font-awesome-icon
                :icon="attrib.lessIsMore ? 'frown' : 'smile'"
                :class="
                  'text-' +
                    backIcon(attrib.value, attrib.maxValue, attrib.lessIsMore)
                "
              />
            </div>
          </div>
        </b-list-group-item>
      </div>
    </div>
  </b-list-group>
</template>
<script>
export default {
  props: ["attribs", "imgPath"],
  methods: {
    isStartMiddleEnd: function(value, max) {
      if (value < max * 0.33) {
        return 1;
      } else if (value > max * 0.66) {
        return 3;
      } else {
        return 2;
      }
    },
    progressVariant: function(value, max, lessIsMore) {
      let whichThird = this.isStartMiddleEnd(value, max);

      if (whichThird == 1) {
        return lessIsMore ? "success" : "danger";
      } else if (whichThird == 3) {
        return lessIsMore ? "danger" : "success";
      } else {
        return "warning";
      }
    },
    frontIcon: function(value, max, lessIsMore) {
      let whichThird = this.isStartMiddleEnd(value, max);

      if (whichThird == 1) {
        return lessIsMore ? "success" : "danger";
      } else if (whichThird == 2) {
        return "warning";
      } else {
        return "muted";
      }
    },
    backIcon: function(value, max, lessIsMore) {
      let whichThird = this.isStartMiddleEnd(value, max);

      if (whichThird == 3) {
        return lessIsMore ? "danger" : "success";
      } else if (whichThird == 2) {
        return "warning";
      } else {
        return "muted";
      }
    },
  },
};
</script>
<style>
.bool-text,
.label-text {
  font-weight: bold;
}
.bool-icon {
  font-size: 1.5rem;
}

.bool-success,
.bool-danger,
.bool-warning {
  border-width: 4px !important;
}

.bool-success {
  border-color: #2eca8b !important ;
}
.bool-danger {
  border-color: #e43f52 !important;
}
.bool-warning {
  border-color: #f17425 !important;
}
.attrib-bg {
  background: #f3f3f3;
}

.bv-avatar {
  width: 5rem;
  height: 5rem;
}

@media (min-width: 300px) and (max-width: 768px) {
  .bv-avatar {
    width: 3rem !important;
    height: 3rem !important;
  }

  .text-responsive {
    font-size: calc(1vw + 1vh);
  }
}
</style>
